<div class="p-4" *ngIf="reports$">
  <app-ep-table [config]="config" [data]="reports$ | async" data-cy="reports-table" />
</div>
